<script>
import i18n from "../i18n";

import simplebar from "simplebar-vue";
import {mapState} from 'vuex';
import TopbarNotificationsList from "@/components/topbarNotificationsList";
import AdminSettings from "@/components/AdminSettings";
import TopbarCampaignCartItemsList from "@/components/topbarCampaignCartItemsList";
import axios from "axios";

/**
 * Nav-bar Component
 */
export default {
  data() {
    return {
      showAdminSettingsModal: false,
      showEmailFrequency: false,
      languages: [
        {
          flag: require("@/assets/images/flags/us.jpg"),
          language: "en",
          title: "English",
        },
        {
          flag: require("@/assets/images/flags/french.jpg"),
          language: "fr",
          title: "French",
        },
        {
          flag: require("@/assets/images/flags/spain.jpg"),
          language: "es",
          title: "Spanish",
        },
        {
          flag: require("@/assets/images/flags/chaina.png"),
          language: "zh",
          title: "Chinese",
        },
        {
          flag: require("@/assets/images/flags/arabic.png"),
          language: "ar",
          title: "Arabic",
        },
      ],
      lan: i18n.locale,
      text: null,
      flag: null,
      value: null,
    };
  },
  computed: {
    ...mapState('user', {
      user: (state) => state.user,
      account: (state) => state.account,
      topbarNotifications: (state) => state.topbarNotifications,
    }),
    ...mapState('notifications', {
      topbarNotifications: (state) => state.topbarNotifications,
    }),
    notPreviewedTopbarNotificationsCount() {
      return this.$store.getters['notifications/notPreviewedTopbarNotificationsCount']
    },
    userType() {
      return this.$store.getters['user/userType'];
    },
    profileName() {
      return this.user.name;
    },
    profileImg() {
      let imgUrl = null;
      if (this.user.main_social_network) {
        imgUrl = this.user.profile_picture_url
      }

      return imgUrl;
    },
    campaignsCount() {
      return this.$store.getters['cart/campaignsCount']
    },
    isNotAribaPage() {
      return !this.$route.meta?.isAriba;
    }
  },
  components: {TopbarCampaignCartItemsList, AdminSettings, TopbarNotificationsList, simplebar},
  mounted() {
    this.value = this.languages.find((x) => x.language === i18n.locale);
    this.text = this.value.title;
    this.flag = this.value.flag;
  },
  methods: {
    navigate(path) {
      if (path !== this.$router.currentRoute.path) {
        this.$router.push(path);
      }
    },
    async logOut() {
      await axios.post(`/logout`);
      this.$store.commit('auth/LOG_OUT');
      await this.$router.push('/login');
    },
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
          !document.fullscreenElement &&
          /* alternative standard method */ !document.mozFullScreenElement &&
          !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
              Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    setLanguage(locale, country, flag) {
      this.lan = locale;
      this.text = country;
      this.flag = flag;
      i18n.locale = locale;
    },
    changeEmailFrequency(email_notification_delay, email_notification_enabled = true) {
      this.$store.dispatch('user/updateAccount', {
        email_notification_delay: email_notification_delay,
        email_notification_enabled: email_notification_enabled,
      });
    },
    openBell() {
      this.showEmailFrequency = false;
      this.$store.dispatch('notifications/previewAll').then()
    },
    readAllNotifications() {
      this.$store.dispatch('notifications/readAll').then()
      this.$refs.notificationBar.hide();
    },
  },
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
<!--          <router-link tag="a" to="/" class="logo logo-dark">-->
<!--            <span class="logo-sm">-->
<!--              <img src="@/assets/images/logo.svg" alt height="22"/>-->
<!--            </span>-->
<!--            <span class="logo-lg">-->
<!--              <img src="@/assets/images/logo-dark.png" alt height="17"/>-->
<!--            </span>-->
<!--          </router-link>-->

          <router-link tag="a" to="/" class="logo logo-light">
            <span class="logo-sm">
              <img src="@/assets/images/logo/logo-sm.png" alt height="45"/>
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo/logo.jpg" alt height="60"/>
            </span>
          </router-link>
        </div>

        <button
            id="vertical-menu-btn"
            type="button"
            class="btn btn-sm px-3 font-size-16 header-item"
            @click="toggleMenu"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button>
      </div>

      <div class="d-flex">

        <b-dropdown
            v-if="userType === 'client'"
            ref="notificationBar"
            right
            menu-class="dropdown-menu-lg p-0"
            toggle-class="header-item noti-icon"
            variant="black"
        >
          <template v-slot:button-content>
            <span>
              <i class="fas fa-shopping-cart"></i>
              <span
                  v-if="campaignsCount > 0"
                  class="badge badge-danger badge-pill"
              >{{ campaignsCount }}</span>
            </span>
          </template>

          <div class="p-3">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="m-0">{{ $t('Cart') }}</h6>
              </div>
            </div>
          </div>
          <simplebar style="max-height: 230px;">

            <topbar-campaign-cart-items-list></topbar-campaign-cart-items-list>

          </simplebar>
        </b-dropdown>

        <!-- <b-dropdown
            ref="notificationBar"
            right
            menu-class="dropdown-menu-lg p-0"
            toggle-class="header-item noti-icon"
            variant="black"
        >
          <template v-slot:button-content>
            <span @click="openBell()">
              <i class="fas fa-bell" :class="{'bx-tada': notPreviewedTopbarNotificationsCount > 0}"></i>
              <span
                  v-if="notPreviewedTopbarNotificationsCount > 0"
                  class="badge badge-danger badge-pill"
              >{{ notPreviewedTopbarNotificationsCount }}</span>
            </span>
          </template>

          <div class="p-3">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="m-0">{{ $t('Notifications') }}</h6>
              </div>
              <div class="col-auto" v-if="topbarNotifications.length > 0">
                <a class="small has-pointer-cursor" @click="readAllNotifications">{{ $t('Mark as read') }}</a>
              </div>
            </div>
          </div>
          <simplebar style="max-height: 230px;">

            <topbar-notifications-list :topbarNotifications="topbarNotifications"></topbar-notifications-list>

          </simplebar>
          <div class="p-2 border-top">
            <div class="btn btn-sm btn-block d-flex align-items-center"
                 @click="showEmailFrequency = !showEmailFrequency">
              <div class="col text-left">
                {{ $t('Change Notification Email Frequency') }}
              </div>
              <div class="col-auto" v-if="showEmailFrequency">
                &times;
              </div>
            </div>
            <div v-if="showEmailFrequency">
              <div class="text-center pt-2">Send Emails...</div>
              <b-dropdown-divider></b-dropdown-divider>
              <a class="dropdown-item has-pointer-cursor" @click.prevent="changeEmailFrequency(0, false)">
                <div>{{ $t('Never') }} <i v-if="!account.email_notification_enabled" class="ml-1 fas fa-check"></i>
                </div>
                <div class="text-secondary">{{ $t("Don't send emails.") }}</div>
              </a>
              <a class="dropdown-item has-pointer-cursor" @click.prevent="changeEmailFrequency(60, true)">
                <div>{{ $t('Periodically') }} <i
                    v-if="account.email_notification_enabled && account.email_notification_delay > 0"
                    class="ml-1 fas fa-check"></i></div>
                <div class="text-secondary">{{ $t("Send emails about once an hour.") }}</div>
              </a>
              <a class="dropdown-item has-pointer-cursor" @click.prevent="changeEmailFrequency(0, true)">
                <div>{{ $t('Instantly') }} <i
                    v-if="account.email_notification_enabled && account.email_notification_delay === 0"
                    class="ml-1 fas fa-check"></i></div>
                <div class="text-secondary">{{ $t("Send emails as soon as possible.") }}</div>
              </a>
            </div>
          </div>
        </b-dropdown> -->

      <b-dropdown right variant="black" toggle-class="header-item" v-if="isNotAribaPage">
          <template v-slot:button-content>
            <img
                class="rounded-circle header-profile-user"
                :src="profileImg ? profileImg : require('@/assets/images/users/user-placeholder.png')"
                alt="Header Avatar"
            />
            <span class="d-none d-xl-inline-block ml-1">{{ $t(profileName) }}</span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>

          <a @click="navigate('/profile')" class="dropdown-item has-pointer-cursor">
            <i class="bx bx-user font-size-16 align-middle mr-1"></i>
            Profil
          </a>

          <a v-if="userType==='influencer'" @click="navigate('/profile')" class="dropdown-item has-pointer-cursor">
            <i class="bx bx-user font-size-16 align-middle mr-1"></i>
            {{ $t('Profile') }}
          </a>

          <!-- <a v-if="userType==='admin'" @click="showAdminSettingsModal = true" class="dropdown-item has-pointer-cursor">
            <i class="bx bx-cog font-size-16 align-middle mr-1"></i>
            {{ $t('Platform Settings') }}
          </a> -->
          <!-- <b-modal v-if="userType==='admin'" @hidden="showAdminSettingsModal = false" v-model="showAdminSettingsModal" title="Platform settings" size="lg" centered hide-footer>
            <admin-settings @saved="showAdminSettingsModal = false"></admin-settings>
          </b-modal> -->

          <!-- <b-dropdown-divider></b-dropdown-divider> -->

          <a @click="logOut" class="dropdown-item text-danger has-pointer-cursor">
            <i class="bx bx-power-off font-size-16 align-middle mr-1 text-danger"></i>
            {{ $t('Odjava') }}
          </a>

        </b-dropdown>
      </div>
    </div>
  </header>
</template>

<style scoped>
.has-pointer-cursor {
  cursor: pointer;
}
</style>
